<template>
  <connect v-if="!networkConnected" />
  <inter v-if="networkConnected"/>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import connect from './components/connect.vue'
import inter from './components/inter.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    connect,
    inter
  },
  data() {
    return {

    }
  },
  computed: {
    getAddress: function () {
      return this.$store.state.account
    },
    networkConnected: function () {
      return (this.$store.state.currentNetwork === "0x13881")
    },
    getNetwork: function () {
      return this.$store.state.currentNetwork;
    }
  },
  methods: {
      async connect() {
        await this.$store.dispatch("connect", true);
    }
  },
  async mounted() {
    await this.connect();
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  margin-top: 60px;
}
</style>
